import { useMemo } from "react";

export const useColumnSelection = (processResponse) => {
  return useMemo(() => {
    const serverColsRaw = processResponse?.columns ?? [];

    const serverCols = serverColsRaw.map((c) => ({
      name: c.name ?? c.column ?? "Unnamed",
      datatype: c.datatype ?? c.type ?? "unknown",
      sample_values: c.sample_values ?? c.examples ?? [],
    }));

    const explicitNumeric = Array.isArray(processResponse?.numeric_columns)
      ? processResponse.numeric_columns
      : null;

    const explicitAll = Array.isArray(processResponse?.all_columns)
      ? processResponse.all_columns
      : serverCols.map((c) => c.name);

    const inferredNumeric = serverCols
      .filter((c) =>
        String(c.datatype).toLowerCase().match(/(int|float|number|double|decimal)/)
      )
      .map((c) => c.name);

    return {
      columns: serverCols.length ? serverCols : [],
      numericColumns: explicitNumeric ?? inferredNumeric,
      allColumns: explicitAll,
    };
  }, [processResponse]);
};